import { render } from "./SuscripcionForm.vue?vue&type=template&id=10263a3a&scoped=true"
import script from "./SuscripcionForm.vue?vue&type=script&lang=js"
export * from "./SuscripcionForm.vue?vue&type=script&lang=js"

import "./SuscripcionForm.vue?vue&type=style&index=0&id=10263a3a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10263a3a"]])

export default __exports__